import { ClerkProvider } from "@clerk/clerk-react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { StyleSheet, View } from "react-native";
import { App } from "./App.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import { Toaster } from "./components/Toast.tsx";
import { ResponsiveProvider } from "./hooks/useResponsive.tsx";
import { ErrorPage } from "./pages/ErrorPage.tsx";
import { LoadingPage } from "./pages/LoadingPage.tsx";
import { colors } from "./utils/design.ts";
import { queryClient } from "./utils/graphql.ts";

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.neutral[900],
    width: "100%",
  },
});

// @ts-expect-error this element is always present in index.html
const rootNode: HTMLDivElement = document.getElementById("root");

ReactDOM.createRoot(rootNode).render(
  <View style={styles.container}>
    <ResponsiveProvider>
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary fallback={(reset, error) => <ErrorPage resetError={reset} error={error} />}>
          <Suspense fallback={<LoadingPage />}>
            <ClerkProvider
              publishableKey={__env.CLERK_PUBLISHABLE_KEY}
              allowedRedirectOrigins={[/http:\/\/localhost:\d+/, /https:\/\/.+\.bireme.io/]}
            >
              <App />
            </ClerkProvider>
          </Suspense>
        </ErrorBoundary>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ResponsiveProvider>
    <Toaster />
  </View>,
);
